import { useMemo } from 'react';
import { chip_theme } from 'framework/chip/constants';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { ChipTheme, ChipThemePartial } from '../types';

export const useChipTheme = (theme: Partial<ChipThemePartial> = chip_theme): ChipTheme => {
  const {
    theme: {
      chip: { general, background, border },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      background: { ...background, ...theme.background },
      border: { ...border, ...theme.border },
    }),
    [theme, general, background, border]
  );
};
